// extracted by mini-css-extract-plugin
export default {"expanded":"AIGeneratedComments_expanded__LYi15"};